export const searchInArray = (data, keys, searchText) => {
  const memo = {};
  if (memo[searchText]) {
    return memo[searchText];
  }

  const results = data.filter(item =>
    keys.some(key => {
      if (typeof item[key] === "string") {
        return item[key].toLowerCase().includes(searchText.toLowerCase())
      } else {
        return item[key] == searchText
      }
    }
    )
  );

  memo[searchText] = results;
  return results;
}